var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass:
        "sidebar-cart__list-item sidebar-cart__list-item--configurable",
    },
    [
      _c("span", { staticClass: "sidebar-cart__list-item-info" }, [
        _c("span", {
          staticClass: "sidebar-cart__list-item-name",
          domProps: { innerHTML: _vm._s(_vm.item.name) },
        }),
        _vm._v(" "),
        _vm.item.variant
          ? _c("span", {
              staticClass: "sidebar-cart__list-item-meta",
              domProps: { innerHTML: _vm._s(_vm.item.variant) },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-cart__list-item-quantity" }, [
        _c(
          "button",
          {
            staticClass: "sidebar-cart__list-item-quantity-minus",
            attrs: { disabled: _vm.locked },
            on: {
              click: function ($event) {
                return _vm.$emit("remove")
              },
            },
          },
          [_c("SVGTrash")],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "sidebar-cart__list-item-quantity-value" }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "sidebar-cart__list-item-quantity-plus",
            attrs: { disabled: _vm.locked },
            on: {
              click: function ($event) {
                return _vm.$emit("copy")
              },
            },
          },
          [_c("SVGDuplicate")],
          1
        ),
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass: "sidebar-cart__list-item-price",
        domProps: {
          innerHTML: _vm._s(
            _vm.$options.filters.madpricecent(_vm.item.originalTotal, "short")
          ),
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-cart__list-item-details" },
        [
          _vm.selectedOptions
            ? _c("div", {
                staticClass: "sidebar-cart__list-item-options",
                domProps: { innerHTML: _vm._s(_vm.selectedOptions) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedExtras
            ? _c("div", { staticClass: "sidebar-cart__list-item-extras" }, [
                _vm.selectedOptions
                  ? _c("span", {
                      staticClass: "sidebar-cart__list-item-subtitle",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("childproducts.extrasTitle")),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  staticClass: "sidebar-cart__list-item-options",
                  domProps: { innerHTML: _vm._s(_vm.selectedExtras) },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("Button", {
            staticClass: "sidebar-cart__list-item-edit",
            attrs: {
              type: "button",
              level: "tertiary",
              text: _vm.$t("cart.itemEdit"),
              arrow: "",
              disabled: _vm.locked,
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("edit")
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }